/** @format */
import { FilterTextField, FilterSelective, FilterTime, FilterDateRange } from 'components';

const status = [
  {
    label: 'همه',
    value: '',
  },
  {
    label: 'موفق',
    value: 'true',
  },
  {
    label: 'ناموفق',
    value: 'false',
  },
];

const columns = [
  {
    title: 'تاریخ فراخوانی',
    field: 'dateCalling',
    align: 'center',
    filterComponent: (props) => <FilterDateRange size="small" {...props} />,
  },
  {
    title: 'زمان فراخوانی',
    field: 'timeCalling',
    align: 'center',
    filterComponent: (props) => <FilterTime size="small" {...props} />,
  },
  {
    title: 'شناسه ارجاع',
    field: 'referenceId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'شناسه کسب و کار',
    field: 'businessId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'نام کسب و کار',
    field: 'businessName',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'شناسه کاربر فراخوانی کننده',
    field: 'callerId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'شناسه فاکتور',
    field: 'invoiceId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'مبلغ فاکتور',
    field: 'invoicePrice',
    align: 'center',
    filterComponent: (props) => <FilterTextField numeric size="small" {...props} />,
  },
  {
    title: 'وضعیت فراخوانی',
    align: 'center',
    field: 'status',
    filterComponent: (props) => <FilterSelective options={status} size="small" {...props} />,
    render: (rd) => (rd.status === 'true' ? 'موفق' : 'ناموفق'),
  },
];

const columnsId = {
  dateCalling: ['2289', '2290'],
  timeCalling: '2291',
  referenceId: '2292',
  businessId: '2293',
  businessName: '2294',
  callerId: '2295',
  invoiceId: '2296',
  invoicePrice: ['2297', '2298'],
  status: '2299',
};

export { columns, columnsId };
